import * as CheckoutActionTypes from 'Types/CheckoutActionTypes';
import * as ShoppingCartActionTypes from 'Types/ShoppingCartActionTypes';
import { flattenShipmentProducts } from 'Utilities/ArrayUtilities';


let currentUrl = '';

const FacebookMiddlewareAction = (action, dispatch, getState) => {

    const sendPageView = () => {
        try {
            let href = window.location.href
            if (href !== currentUrl) {
                if (!href.toLowerCase().includes("/shoppingcart") && !href.toLowerCase().includes("/confirmation")) {
                    fbq('track', "PageView");
                }
                currentUrl = href;
            }
        } catch (e) {
            console.error(e);
        }
    }

    try {
        switch (action.type) {
            case CheckoutActionTypes.HYDRATED_CONFIRMATION_STEP:
                let transaction = action.payload.checkoutTransactionRm;
                var products = flattenShipmentProducts(transaction).map(function (p) {
                    return {
                        'id': p.skuBase, // string
                        'name': p.title, // string
                        'category1': p.category, // string
                        'category2': p.subcategory, // string
                        'category3': p.partType, // string
                        'brand': p.brand, // string
                        'variant': p.skuVariant, // string
                        'price': p.rawPostDiscountUnitPrice, // decimal
                        'quantity': p.quantity // int
                    }
                })
                
                var orderNumber = transaction.confirmation.orderNumbers.length > 1
                    ? transaction.confirmation.masterOrderNumber
                    : transaction.confirmation.orderNumbers[0];

                SMI.Facebook.event('Purchase',
                    {
                        products: products,
                        transactionId: orderNumber,
                        revenue: transaction.confirmation.orderSubTotal,
                        tax: transaction.confirmation.taxTotal,
                        shipping: transaction.confirmation.shippingTotal,
                        coupon: transaction.paymentMethodContainer.promos.map(promo => promo.promoCode).toString(),
                        value: transaction.confirmation.orderSubTotal,
                        currency: 'USD'
                    })
                break
            case ShoppingCartActionTypes.ENTER_CHECKOUT:
                fbq('track', 'InitiateCheckout', {
                    value: action.payload.orderPrice,
                    currency: 'USD'
                })
            default:
                sendPageView();
                break
        }

    } catch (e) {
        console.error(e)
    }

}
export default FacebookMiddlewareAction;